import { styled } from "@mui/material/styles";

// Components
import { Box, Typography } from "@mui/material";
import { Button, theme } from "../Common";

const styledName = "Layout";

export const StyledLayoutWrapper = styled(Box, { name: styledName })({
  "&": {
    width: "calc(100vw - 280px)",
    padding: "0 20px",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
});

export const StyledLayoutContent = styled(Box, { name: styledName })({
  "&": {
    display: "flex",
    width: "100%",
    padding: "20px 0",
    justifyContent: "space-evenly",
    height: "calc(100vh - 80px)",
    gap: "20px",
  },
});

export const StyledAddBtn = styled(Button, { name: styledName })({
  "&": {
    width: "340px",
    backgroundColor: "white",
    margin: "auto",
    marginTop: "20px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
  },
});

export const StyledListLabel = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "2rem",
    width: "100%",
    textAlign: "start",
    marginBottom: "20px",
  },
});

export const StyledErrorMessage = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.error.main,
  },
});

export const StyledNotFound = styled(Typography, { name: styledName })({
  fontSize: "1.6rem",
  width: "100%",
  textAlign: "center",
});
